import colors from './colors';
import darkTheme from './darkTheme';

export default darkTheme(colors);
